/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint react/prop-types: off */
import React, { useRef, useEffect } from 'react'
import {
  Col,
  FormInput,
  FormInputCheckbox,
  Row,
  Tip,
  FormInputText
} from 'camino-react'
import { MixedTags } from '@yaireo/tagify/dist/react.tagify'

const customValues = [
  { label: 'Title', value: 'title' },
  { label: 'ID', value: 'id' },
  { label: 'Client', value: 'client' },
  { label: 'Description', value: 'description' },
  { label: 'Ticket Type', value: 'ticket_type' },
  { label: 'Client Contact', value: 'client_contact' },
  { label: 'Priority', value: 'priority' }
]

const SendTeamsNotificationAction = ({
  update,
  operations: { title, subtitle, details, webhook_url: webhookURL }
}) => {
  const titleRef = useRef()
  const subtitleRef = useRef()

  const prepareDetails = () => {
    if (details) return

    const initialDetails = customValues.map(({ value, label }) => ({
      value,
      label,
      checked: false
    }))

    update('details', initialDetails)
  }

  useEffect(prepareDetails, [])

  const settings = {
    pattern: /#/,
    enforceWhitelist: true,
    editTags: false,
    mixTagsInterpolator: ['<<', '>>'],
    dropdown: {
      enabled: 0,
      position: 'text'
    },
    whitelist: customValues.map(customValue => (
      { value: customValue.label, field: customValue.value }
    ))
  }

  const handleTitle = () => {
    update('title', titleRef.current.state.lastOriginalValueReported)
  }

  const handleSubtitle = () => {
    update('subtitle', subtitleRef.current.state.lastOriginalValueReported)
  }

  const handleDetail = (value) => {
    const newDetails = [...details]
    const detailToUpdate = newDetails.find(detail => detail.value === value)
    detailToUpdate.checked = !detailToUpdate.checked

    update('details', newDetails)
  }

  return (
    <Row>
      <Col>
        <div className="flex items-center justify-end text-xl">
          <span className="mr-2">How to add custom values?</span>

          <Tip content="If you want to add custom values, just type # and then a
              list of available values will appear"
          />
        </div>

        <label>Title</label>
        <MixedTags
          className="mb-4 border border-blue-100 rounded focus:border-blue-300"
          tagifyRef={titleRef}
          settings={settings}
          onChange={handleTitle}
          onInput={handleTitle}
          value={title}
        />

        <label>Subtitle</label>
        <MixedTags
          className="border border-blue-100 rounded focus:border-blue-300"
          tagifyRef={subtitleRef}
          settings={settings}
          onChange={handleSubtitle}
          onInput={handleSubtitle}
          value={subtitle}
        />

        <div className="my-4">
          <div className="flex items-center">
            <span className="mr-2">Message Details</span>
            <i className="text-lg">(Details will be displayed as a list of values)</i>
          </div>

          <div className="flex flex-wrap items-center">
            {details?.map(({ label, checked, value }) => (
              <div className="w-1/3 mt-2">
                <FormInputCheckbox
                  value={checked}
                  onValue={() => handleDetail(value)}
                >
                  {label}
                </FormInputCheckbox>
              </div>
            ))}
          </div>
        </div>

        <div className="flex items-center justify-end text-xl">
          <a
            className="text-blue-500 duration-300 hover:text-blue-600"
            href="https://support.microsoft.com/en-us/office/post-a-workflow-when-a-webhook-request-is-received-in-microsoft-teams-8ae491c7-0394-4861-ba59-055e33f75498"
          >
            How to create teams workflow?
          </a>
        </div>

        <FormInput label="Webhook URL">
          <FormInputText
            placeholder="Webhook URL"
            value={webhookURL}
            onValue={e => update('webhook_url', e)}
          />
        </FormInput>
      </Col>
    </Row>
  )
}

export default SendTeamsNotificationAction
